import { Box } from "@mui/material"

export default function Comment({text, display, onClick}){

    return text.length < 200 ? text : 

        <Box onClick={onClick} sx={{cursor: 'pointer'}}>
            {display ? 
                <>{text} <u>Voir moins</u></> 
                : 
                <>{text.substring(0, 200) + '...'} <u>Voir plus</u></>
            }
        </Box>

}
